import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElPopover } from 'element-plus';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Popover',
  props: {
    placement: { default: 'bottom' },
    width: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElPopover), {
    width: _ctx.width,
    placement: _ctx.placement,
    "popper-class": "popover",
    teleported: false
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "trigger")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "body")
    ]),
    _: 3
  }, 8, ["width", "placement"]))
}
}

})